export default '/build/a1c17fa0.svg'